import * as React from "react";

import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

import { modifyAlertAction } from "@/api/alert";
import usePlatform from "@/hooks/usePlatform";

import { IAlertItem } from "./utils";

interface LabelFormProps extends DialogProps {
  data?: IAlertItem;
  onSuccess: () => void;
}

export default function LabelForm(props: LabelFormProps) {
  const { data, onSuccess, ...dialogProps } = props;

  const { isPc } = usePlatform();

  const [loading, setLoading] = React.useState(false);
  if (!data) {
    return null;
  }
  return (
    <Dialog
      {...dialogProps}
      PaperProps={{
        component: "form",
        onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();

          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries((formData as any).entries());

          const labelName = formJson.label;

          await modifyAlertAction({
            alert_id: String(data.alert_id),
            filter_criteria: {
              ...data.filterData,
              labelNames: Array.from(new Set([...(data.filterData.labelNames ?? []), labelName])),
            },
            info: data.info,
          });

          dialogProps?.onClose?.(event, "backdropClick");

          onSuccess();
        },
      }}
    >
      <DialogTitle>Label your alerts</DialogTitle>
      <DialogContent className={isPc ? "w-[500px]" : "w-[80vw]"}>
        <TextField
          autoFocus
          required
          margin="dense"
          id="label"
          name="label"
          label="Label Name"
          fullWidth
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            dialogProps?.onClose?.(e, "backdropClick");
          }}
        >
          Cancel
        </Button>
        <LoadingButton loading={loading} type="submit" loadingPosition="start">
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
